import React from "react";
import { Box } from "@mui/material";
import { useDrop } from "react-dnd";

const SubLevel = ({
  data,
  level,
  title,
  parentIndices,
  levelIndex,
  renderMenuItems,
  onMove, // Add onMove prop
}) => {
  // Custom drop target hook
  const [, drop] = useDrop({
    accept: "MENU_ITEM",
    drop: (draggedItem, monitor) => {
      // Prevent dropping if the drop is not over a valid target
      if (!monitor.isOver({ shallow: true })) return;

      // Prepare drop target information
      const dropTarget = {
        index: data.length, // Default to end of list if no specific index
        level: level,
        levelIndex: levelIndex,
      };

      // Call onMove if provided
      if (onMove) {
        onMove(draggedItem, dropTarget);
      }
    },
    canDrop: (item) => {
      // Only allow dropping at the same level
      return item.level === level;
    },
  });

  if (!data) return null;

  return (
    <Box
      ref={drop}
      sx={{
        borderRadius: "4px",
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        minWidth: "220px",
        borderRight: level < 3 ? "1px solid #e0e0e0" : "none",
        gap: 1,
        // Add visual drop target styling
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.05)",
        },
      }}
    >
      {level === 2 && levelIndex === 1 ? (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 1,
          }}
        >
          {renderMenuItems(data, level, parentIndices, levelIndex)}
        </Box>
      ) : (
        renderMenuItems(data, level, parentIndices, levelIndex)
      )}
    </Box>
  );
};

export default SubLevel;
